const checkpoints = [
  {
    icon: 'ri-file-list-3-line',
    title: '先查公开记录',
    text: '检索平台是否出现过公开通报、行政处罚或应用下架记录。第三方记录比官网承诺更接近真实合规水位。',
  },
  {
    icon: 'ri-file-text-line',
    title: '再读隐私政策',
    text: '重点看两件事：数据用途是否写清、撤回同意是否方便。写法含糊或撤回路径极深，都值得多留一个心眼。',
  },
  {
    icon: 'ri-toggle-line',
    title: '检查默认开关',
    text: '默认开启的营销共享与免密代扣是高发问题。默认应为关闭，由你主动选择开启，而不是反过来。',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: '看响应渠道',
    text: '出问题不可怕，无人响应才可怕。有对外可用的安全反馈渠道、且响应速度正常的平台，整体更值得信任。',
  },
];

export default function RiskChecklist() {
  return (
    <section className="border-b border-background-200 bg-background-100/60">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div className="max-w-2xl">
            <p className="text-xs font-medium tracking-[0.2em] text-primary-700">风险自查四步</p>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              在授权之前，花五分钟做个判断
            </h2>
            <p className="mt-3 text-sm leading-7 text-foreground-600">
              不需要懂技术，也不需要读完几百页协议。按下面四步走一遍，大多数高风险平台会露出破绽。
            </p>
          </div>
          <a
            href="#latest-incidents"
            className="inline-flex w-fit items-center gap-1.5 whitespace-nowrap rounded-md border border-foreground-300 px-4 py-2 text-sm text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-700"
          >
            直接看案例
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-arrow-down-line text-sm"></i>
            </span>
          </a>
        </div>

        <ol className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {checkpoints.map((item, index) => (
            <li
              key={item.title}
              className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 md:p-6"
            >
              <div className="flex items-center justify-between">
                <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                  <i className={`${item.icon} text-xl`}></i>
                </span>
                <span className="font-heading text-2xl font-black text-background-300">
                  {String(index + 1).padStart(2, '0')}
                </span>
              </div>
              <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">{item.title}</h3>
              <p className="mt-2 text-sm leading-6 text-foreground-600">{item.text}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}